import { CasePhaseStatusIcon } from '@/components/screens/lawyerapp/cases/case-details-layout';
import { Typography } from '@/components/common';
import { PhaseName } from '@/interfaces';
import * as React from 'react';

export const CaseClientTitle: React.FC<{
	name: PhaseName;
	hidePhase?: boolean;
}> = ({ name, hidePhase }) => {
	return (
		<div>
			<Typography type="semibold-20" className="text-left">
				Case Clients
			</Typography>
			{!hidePhase && (
				<div className="flex items-center gap-x-2 mt-1.5">
					<CasePhaseStatusIcon name={name} size="small" />
					<Typography
						type="regular-14"
						className="text-opacity-black text-left"
					>
						{name}
					</Typography>
				</div>
			)}
		</div>
	);
};
